import {SET_CHART_TYPE} from '../actions/pdfReport';
import {ISetChartTypeAction} from '../actions/types/pdfReport.types';

export interface ChartTypeReducerState {
    sequenceChartType: string;
}

export const chartTypePreloadedState: ChartTypeReducerState = {
    sequenceChartType: 'Correct',
};

export const chartTypeReducer = (
    state: ChartTypeReducerState = chartTypePreloadedState,
    action: ISetChartTypeAction
): ChartTypeReducerState => {
    switch (action.type) {
        case SET_CHART_TYPE:
            return {
                ...state,
                sequenceChartType: action.payload,
            };
        default:
            return state;
    }
};
